export const FOOTER_MODAL = {
  TERMS: "terms",
  PRIVACY: "privacy",
} as const;
